import { ChangeOffersEligibleListInterfaceState, initialChangeOffersEligibleListState } from '../state/change-offers-eligible-list.state';
import { ChangeOffersEligibleListActions, EChangeOffersEligibleListActions } from '../actions/change-offers-eligible-list.actions';

export function changeFfersEligibleListReducer(state: ChangeOffersEligibleListInterfaceState = initialChangeOffersEligibleListState, action: ChangeOffersEligibleListActions): ChangeOffersEligibleListInterfaceState {
  switch (action.type) {
    case EChangeOffersEligibleListActions.GetChangeOffersEligibleListSuccess: {
      return { ...state, response: action.payload };
    }

    default:
      return state;
  }
};
